import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import FloatingAlert from "../../../components/FloatingAlert/FloatingAlert";
import bgSliders from "../../../helpers/bgSliders";
import "./SignupPage.scss";
import LibyanaMarketingSignupPageDisplay from "./SignupPage.styled";
import { setLoginData } from "../../../helpers/helpers";
import { Trans, withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { setAgencyData, saveTracker } from "../../../helpers/agencyTracker";
import queryString from "query-string";
// import * as localLang from "../../../i18n/i18n";
// import TagManager from 'react-gtm-module'

// const randomBg = bgSliders.getRandomBg();
function LibyanaMarketingSignupPage({ t }) {
  const [activeData, setActiveData] = useState("");
  const [transactionidentify, setTransactionidentify] = useState("");
  const [checkPhone, setCheckPhone] = useState(false);

  const [showverif, setShowverif] = useState(false);
  const [verifyCode, setVerifyCode] = useState("");
  const [errorMesg, setErrorMesg] = useState(false);
  const [verfiErrorMesg, setVerfiErrorMesg] = useState(false);
  const [errorresverify, seterrorresverify] = useState("");

  const [errorMesgSubscribe, setErrorMesgSubscribe] = useState("");
  const [signupPlan, setSignupPlan] = useState("d");
  const [otpid, setotpid] = useState("");
  const [showLoading, setshowLoading] = useState(false);

  const history = useHistory();
  const [alert, setAlert] = useState(false);
  let currentURL = window.location.href;
  let BaseURL = "https://api.playit.mobi/api/";

  const plans = [
    {
      plan: "d",
      name: "Daily",
    },
    {
      plan: "w",
      name: "Weekly",
    },
  ];


  function gtag_report_conversion() {
    let tracker_value = localStorage.getItem("tracker");
    if (localStorage.getItem(tracker_value) != "1") {
      window.gtag("event", "conversion", {
        send_to: "AW-619421651/C_ScCIHe_qcZENO_rqcC",
      });
      localStorage.setItem(tracker_value, "1");
    }
    return false;
  }

  useEffect(() => {
    if (currentURL.startsWith("https://")) {
      BaseURL = "https://apissl.playit.mobi/api/";
    }
    const params = queryString.parse(window.location.search);
    if (!params.lang) {
      localStorage.setItem("i18nextLng", "ar");
    } else {
      localStorage.setItem("i18nextLng", "ar");
    }
    if (document.readyState === "complete") {
      headerSignup();
    } else {
      window.addEventListener('load', () => {
        
        headerSignup();       
      });
    }
    const urlsearch = window.location.search;
    if (urlsearch !== "") {
      setAgencyData(urlsearch);
    }
  }, []);

  async function headerSignup() {
    

    if (currentURL.startsWith("https://")) {
      BaseURL = "https://apissl.playit.mobi/api/";
    }

    var url =
      BaseURL +
      `v2/connex-libya/get-protected-script?targeted_element=%23cta_button`;
    axios
      .get(url)
      .then((res) => {
  
        if (res.data.status === true) {
          const addScript = document.createElement("script");
            addScript.innerHTML = res.data.dcbprotect;
            document.body.appendChild(addScript); 
            
            setTransactionidentify(res.data.transaction_identify);
            setshowLoading(false);
            
            var event = new Event("DCBProtectRun");
            document.dispatchEvent(event);
        } else {
          setErrorMesg(true);
          setErrorMesgSubscribe(res.data.message);
        }

        setshowLoading(false);
      })
      .catch(function (error) {
      })
      .finally(function () {
      });
  }

  // save tracker
  const tracker = async (GMSISDN) => {
    var datag = {};
    if (localStorage.getItem("tracker")) {
      var op_id = "CcoIV1eQFA";
      if (
        GMSISDN.startsWith("21891") ||
        GMSISDN.startsWith("21893") ||
        GMSISDN.startsWith("91") ||
        GMSISDN.startsWith("93")
      ) {
        op_id = "qiL2bqfIL3";
      }

      datag = {
        key: "parameter",
        company: localStorage.getItem("trackerCompany"),
        value: localStorage.getItem("tracker"),
        identifierKey: "id",
        identifierValue: op_id,
        phoneNum: GMSISDN,
      };
    }
    await saveTracker(datag);
  };

  const Subscribe = async (e) => {
    setActiveData(e.target.phone_number.value);
    const phone_number_val = e.target.phone_number.value;
    e.preventDefault();

    if (phone_number_val) {
      var phon_n = phone_number_val.toString();

      if (currentURL.startsWith("https://")) {
        BaseURL = "https://apissl.playit.mobi/api/";
      }
      let url = BaseURL + `v2/connex-libya/send-otp-login`;

      const options = {
        msisdn: phon_n,
        transaction_identify: transactionidentify,
       
      };

      setshowLoading(true);
      await axios
        .post(url, options)
        .then((res) => {
          if (res.data.status === true) {
            if (res.data.user_id) {
              setLoginData(
                res.data.user_id,
                res.data.token,
                res.data.user_name,
                res.data.photo,
                res.data.operator_id,
                res.data.user_email,
                res.data.msisdn
              );
            }
            if (res.data.otpid) {
              setotpid(res.data.otpid);
            }
            setShowverif(true);
          } else {
            if (res.data.msg != null) {
              setErrorMesgSubscribe(res.data.msg);
              setErrorMesg(true);
            } else {
              setErrorMesgSubscribe(t("register.SUBSCRIBE_ERROR"));
              setErrorMesg(true);
            }
            // setShowverif(true)
          }
          setshowLoading(false);
        })
        .catch(function (error) {
          setErrorMesg(true);
          setShowverif(false);
        })
        .finally(function () {
        });
    }
  };

  const verify = async (e) => {
    e.preventDefault();
    if (verifyCode && verifyCode.length === 4) {
      var phon_n = activeData;
      setshowLoading(true);
      if (currentURL.startsWith("https://")) {
        BaseURL = "https://apissl.playit.mobi/api/";
      }

      let url = BaseURL + "v2/connex-libya/login-confirm";

      axios
        .get(url + `?msisdn=${phon_n}&pincode=${verifyCode}&plan=w`)
        .then((res) => {
          if (res.data.status === true) {
            setVerfiErrorMesg(false);
            if (res.data.data.user_id) {
              if (res.data.data.subscription_status) {
                if (res.data.code !== 1) {

                  tracker(phon_n);
                  gtag_report_conversion();
                }

               window.location.href =`https://libya.playit.mobi/catch-Libyana?msisdn=${res.data.data.username}`;
              } else {
                seterrorresverify(res.data.data.message);
                setVerfiErrorMesg(true);
              }
              
            } else {
              if (res.data.message != null) {
                seterrorresverify(res.data.msg);
                setVerfiErrorMesg(true);
              }
            }
           
          } else {
            if (res.data.msg != null) {
              seterrorresverify(res.data.msg);
              setVerfiErrorMesg(true);
              setTimeout(() => {
                seterrorresverify("");
              setVerfiErrorMesg(false);
              setShowverif(false);
              }, 3000);
            } else {
              // setErrorMesgSubscribe(t("register.SUBSCRIBE_ERROR"));
              seterrorresverify(t("register.VERIFY_ERROR"));
              setVerfiErrorMesg(true);
              setTimeout(() => {
                seterrorresverify("");
              setVerfiErrorMesg(false);
              setShowverif(false);
              }, 3000);
            }
           
          }
          setshowLoading(false);
        })
        .catch(function (error) {
         
        })
        .finally(function () {
        });
    }
  };

  const plansOptions = plans.map((c, k) => {
    return (
      <option key={`plan-${k}`} value={c.plan}>
        {c.name}
      </option>
    );
  });

  return (
    <LibyanaMarketingSignupPageDisplay>
      {alert && (
        <FloatingAlert type={"danger"}>
          In order to signup please turn your mobile data.
        </FloatingAlert>
      )}

      {errorMesg ? (
        <FloatingAlert type={"error"}>
          <Trans>{errorMesgSubscribe}</Trans>
        </FloatingAlert>
      ) : null}

      {verfiErrorMesg ? (
        <FloatingAlert type={"error"}>
          <Trans>{errorresverify}</Trans>
        </FloatingAlert>
      ) : null}

      <div className="operatorSignup">
        <div className="formsLayout formsLayoutjawal">
          <div className="header header_gamezone">
            <Link to="/">
              <div
                className="logo logo gamezoneLogo cptpl_logo"
                alt="service logo"
              />
            </Link>
          </div>
          {!showverif ? (
            <div className="links-Section links-Sectionjawwalgamezorid">
              {/* <h3 style={{ paddingBottom: '1px' }} className="gamezoridcontent" id="gamezoridcon">
                <Trans>Your content is ready!</Trans>
              </h3> */}
              <div className="play"></div>

              <div className="main_span cptpl_service">
                <p>
                  {" "}
                  <Trans>
                    Playit offers more than 500 games for game lovers
                  </Trans>
                </p>
              </div>

              <form
                name="formsubmit"
                onSubmit={(e) => {
                  e.preventDefault();
                  Subscribe(e);
                }}
              >
                <input
                  type="text"
                  className="input gamezoneInput gamezonekeyph"
                  value="218"
                  disabled={true}
                />
                {/* {t("Enter_your_phone_number")} */}
                <input
                  type="text"
                  className="input gamezoneInput gamezonenumph"
                  placeholder="XX XXX XX XX"
                  name="phone_number"
                  //                value=""
                  disabled={checkPhone === true}
                  //onChange={(e) => setActiveData(e.target.value.replace(/[^0-9]/g, ""))}
                />
                <br />
                <br />
                <br />
                <button
                  id="cta_button"
                  className="btn reg_but cptpl_subscribe"
                  //disabled={activeData ? "" : "disabled"}
                  type="submit"
                >
                  {t("Subscribe")}
                </button>
              </form>

             

              <div className="footer jawwalgamezoridFooter zainiqFooter">
                {!showverif ? "" : null}
                <div className="ncellTos jawwalgamezoridncellTos ">
                  {/* <h3><Trans>terms_and_conditions</Trans></h3> */}
                  {/*                   <p style={{lineHeight:"1.2",margin:"0 0 5px 0"}}><Trans>libyana-condtion_tandc1</Trans></p>
                   */}{" "}
                  {/* <p><Trans>zainiq-condtion-gamezone_tandc2</Trans></p> */}
                  {/*                   <p style={{lineHeight:"1.2",margin:"0 0 5px 0"}}><Trans>libyana-condtion_tandc3</Trans></p>
                   */}{" "}
                  <p
                    className="price_title cptpl_price"
                    style={{
                      lineHeight: "1.2",
                      margin: "0 0 5px 0",
                      fontSize: "20px !important",
                    }}
                  >
                    <Trans>libyana-condtion_tandc4</Trans>
                  </p>
                  <p
                    className="cptpl_terms"
                    style={{ lineHeight: "1.2", margin: "0 0 5px 0" }}
                  >
                    <Trans>libyana-condtion_term</Trans>
                  </p>
                   <h5>
                       <a href="/tos" className="text-decoration-none me-2">
                         <Trans>terms_and_conditions</Trans>
                       </a>
                       |    
                       <a href="http://playit.mobi/ar_privacypolicy.html" className="text-decoration-none ms-2">
                         <Trans>privacy_policy</Trans>
                       </a>
                     </h5>
                  {/* <p style={{lineHeight:"2px"}}><Trans>libyana-condtion_tandc5</Trans></p> */}
                  {/*   <p style={{lineHeight:"1.2",margin:"0 0 5px 0"}}><Trans>libyana-condtion_tandc6</Trans></p> */}
                  {/* <p> <Trans>JAWWALGameSUBSCRIBE_TAX</Trans> </p>
                  <p> <Trans>JAWWALGamSUBSCRIBEUNSUBSCRIBE</Trans> </p> */}
                </div>
              </div>
            </div>
          ) : null}

          {showverif ? (
            <div className="verfiySection">
              <p>
                <Trans>verifycodeJawwalGameszorid</Trans>
              </p>
              <p>الرجاء الانتظار حتى وصول رمز التحقق الى هاتفكم</p>

              <input
  type="text"
  className="input"
  value={verifyCode}
  placeholder={t("Enter_verifycode")}
  maxLength={4}
  onChange={(e) => 
    setVerifyCode(e.target.value.replace(/[^0-9]/g, ""))
  }
/>

              <br></br>
              <br></br> <br></br>
              <button
                className="btn"
                disabled={verifyCode ? "" : "disabled"}
                onClick={(e) => {
                  verify(e);
                }}
              >
                {t("Verify")}
              </button>
            </div>
          ) : null}

          {showLoading ? (
            <div className="load">
              <div className="spinerC">
                <div className="spinner"></div>
              </div>
            </div>
          ) : null}
        </div>
      </div>

      {/* <div className='operatorSignup'>
        <div className="formsLayout">

          <div className='header'>
            <Link to="/">
              <div className='logo' />
            </Link>
          </div>

          {!showverif ?

            <div className="center">
              <form>
                <div>
                   <select

                    className="select"
                    defaultValue={signupPlan}
                    onChange={e => setSignupPlan(e.target.value)}
                  >

                    <Trans>{plansOptions}</Trans>
                  </select>
                

                  <input
                    type="number"
                    className="input"
                    placeholder={t("Enter_your_phone_number")}
                    value={activeData}
                    disabled={checkPhone === true}
                    onChange={e => setActiveData(e.target.value)}
                  />
                  <br></br>
                  <br></br> <br></br>
                  <button
                    className="btn"
                    disabled={activeData ? "" : "disabled"}
                    onClick={(e) => {
                      Subscribe(e);
                    }} >
                    {t("Subscribe")}
                  </button>

                </div>
              </form>
            </div>

            : null}




          {showverif ?
            <div className="verfiySection">
              <p><Trans>verifycodeSub</Trans></p>
              <input
                type="number"
                className="input"
                value={verifyCode}
                placeholder={t("Enter_verifycode")}
                onChange={e => setVerifyCode(e.target.value)}
              />
              <br></br>
              <br></br> <br></br>
              <button
                className="btn"
                disabled={verifyCode ? "" : "disabled"}
                onClick={(e) => {
                  verify(e);
                }} >
                {t("Verify")}
              </button>

            </div> : null
          }


          <div className="footer">
           
            <div className="ncellTos">

            </div>
          </div>

        </div>
      </div> */}
    </LibyanaMarketingSignupPageDisplay>
  );
}
export default withTranslation()(LibyanaMarketingSignupPage);
